import { useBrand } from '../context/BrandContext';
import FastestFormFormList from './fastestform/FormList';
import AbleFormList from './able/FormList';

export default function FormList() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleFormList /> : <FastestFormFormList />;
}
